import { DashUIDivisor } from "./DashUIDivisor";

export default DashUIDivisor;